module.exports = __webpack_public_path__ + "img/9788954612111.296d1284.jpg";